// One matchMedia and one listener for the process. False on the server and the hydration render, so consumers
// pair it with useHydrated(); settle layout in CSS where you can and reach for this only inside JSX.

import { useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 768
// For imperative callers a hook cannot reach; must match the max-width of the stack's media query in app.css.
export const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

let query: MediaQueryList | null = null
let matches = false
const listeners = new Set<() => void>()

function onChange(): void {
  const next = query?.matches ?? false
  if (next === matches) return
  matches = next
  for (const l of listeners) l()
}

function subscribe(listener: () => void): () => void {
  // On first subscription, never at module scope: this module is in the SSR bundle, where window is absent.
  if (!query) {
    query = window.matchMedia(MOBILE_QUERY)
    matches = query.matches
    query.addEventListener('change', onChange)
  }
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** The live value once anything has subscribed; `false` before that, which is also what the server answers. */
function getSnapshot(): boolean {
  return query ? query.matches : matches
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
